module.exports = __webpack_public_path__ + "static/media/instagram.257d9ca5.svg";